import { render, staticRenderFns } from "./TaskView.vue?vue&type=template&id=1270476e&"
import script from "./TaskView.vue?vue&type=script&lang=js&"
export * from "./TaskView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports